<app-waiting [success]="success" [cancel]="cancel" class="mt-8"></app-waiting>